import { useEffect, useState } from "react";
import { request } from "@/request";
import getBackendURL from "@/api/api";
import { isValidId } from "@/actions/util";

export interface ShapeHistoryRow {
	question_id: string;
	entries: { esr_id: string; label: string; has_shapes: boolean }[];
}

// Grid of shape versions: a row per question, a column per ESR up to `esrId`.
export function useShapeHistory(
	esrId: string,
	questionIds: string[],
	shapeVersion: number,
): ShapeHistoryRow[] {
	const [history, setHistory] = useState<ShapeHistoryRow[]>([]);
	const questions = questionIds.join(",");

	useEffect(() => {
		if (!isValidId(esrId) || !questions) return;

		let cancelled = false;
		request(
			getBackendURL(`/esr/shape_history/${esrId}/?questions=${questions}`),
		).then(({ data }) => {
			if (cancelled) return;
			setHistory(data.history);
		});

		return () => {
			cancelled = true;
		};
	}, [esrId, questions, shapeVersion]);

	return history;
}